/* iPhumat — Cart drawer AJAX.
 * Aucun framework. Utilise les routes /cart/{add,change}.js de Shopify.
 * S'ouvre :
 *  - via [data-cart-open] (icône panier)
 *  - automatiquement après ajout au panier (formulaire [data-add-to-cart] ou /cart/add)
 */
(function () {
  'use strict';

  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const scrim   = document.querySelector('[data-cart-scrim]');
  const closeBtn = drawer.querySelector('[data-cart-close]');
  const body    = drawer.querySelector('[data-cart-body]');
  const foot    = drawer.querySelector('[data-cart-foot]');
  const totalEl = drawer.querySelector('[data-cart-total]');
  const titleEl = drawer.querySelector('[data-cart-title]');
  // Pack Protection proposé dans le panier : visible dès qu'il y a un
  // appareil, masqué si le pack y est déjà.
  const upsell  = drawer.querySelector('[data-cart-upsell]');
  const upsellForm = drawer.querySelector('[data-cart-upsell-form]');
  const upsellId = upsellForm
    ? (upsellForm.querySelector('input[name="id"]') || {}).value : null;

  let lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-modal', 'true');
    if (scrim) { scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add('is-on')); }
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => closeBtn && closeBtn.focus(), 60);
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('aria-modal', 'false');
    if (scrim) { scrim.classList.remove('is-on'); setTimeout(() => { scrim.hidden = true; }, 250); }
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function money(cents) {
    try { return new Intl.NumberFormat('fr-FR', { style:'currency', currency: window.Shopify && Shopify.currency && Shopify.currency.active || 'EUR' }).format(cents / 100); }
    catch (_) { return (cents/100).toFixed(2) + ' €'; }
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept:'application/json' } })
      .then(r => r.json())
      .then(cart => { renderJS(cart); updateChrome(cart); return cart; });
  }

  function updateChrome(cart) {
    if (titleEl) titleEl.textContent = cart.item_count > 0 ? 'Bientôt à vous.' : 'Votre panier patiente.';
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (foot) foot.hidden = cart.item_count === 0;
    if (upsell) {
      const already = upsellId && cart.items.some(
        it => String(it.variant_id) === String(upsellId));
      upsell.hidden = cart.item_count === 0 || !!already;
    }
    // Badge
    document.querySelectorAll('[data-cart-count]').forEach(b => {
      b.textContent = cart.item_count;
      b.hidden = cart.item_count === 0;
    });
  }

  function renderJS(cart) {
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Aucun appareil pour l’instant.</p><a href="/collections/all" class="btn btn--accent">Voir la boutique</a></div>';
      return;
    }
    const items = cart.items.map(it => {
      const img = it.image ? '<img src="' + (it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2')) + '" alt="" width="80" height="80" loading="lazy">' : '';
      return '<li class="cart-drawer__item" data-key="' + it.key + '">' +
        '<a href="' + it.url + '" class="cart-drawer__media" aria-hidden="true" tabindex="-1">' + img + '</a>' +
        '<div class="cart-drawer__info">' +
          '<a href="' + it.url + '" class="cart-drawer__name">' + esc(it.product_title) + '</a>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="cart-drawer__variant">' + esc(it.variant_title) + '</p>' : '') +
          '<div class="cart-drawer__row">' +
            '<div class="qty qty--sm">' +
              '<button type="button" data-cart-update="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Diminuer">−</button>' +
              '<input type="number" value="' + it.quantity + '" min="0" inputmode="numeric" data-cart-input="' + it.key + '">' +
              '<button type="button" data-cart-update="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Augmenter">+</button>' +
            '</div>' +
            '<span class="cart-drawer__price">' + money(it.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer__remove" data-cart-update="' + it.key + '" data-qty="0" aria-label="Retirer">×</button>' +
      '</li>';
    }).join('');
    body.innerHTML = '<ul class="cart-drawer__items" role="list">' + items + '</ul>';
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

  // Quantity changes
  body.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cart-update]');
    if (!btn) return;
    const key = btn.getAttribute('data-cart-update');
    const qty = parseInt(btn.getAttribute('data-qty'), 10);
    change(key, isNaN(qty) ? 0 : Math.max(0, qty));
  });
  body.addEventListener('change', function (e) {
    const inp = e.target.closest('[data-cart-input]');
    if (!inp) return;
    const key = inp.getAttribute('data-cart-input');
    const qty = Math.max(0, parseInt(inp.value, 10) || 0);
    change(key, qty);
  });
  function change(key, qty) {
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(r => r.json()).then(() => refresh());
  }

  // Open/close
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refresh().then(open); }
    if (e.target.closest('[data-cart-close]') || e.target === scrim) { close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Intercepter les forms d'ajout au panier
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.action && form.action.match(/\/cart\/add(\.js)?(\?|$)/)) {
      e.preventDefault();
      const fd = new FormData(form);
      fetch('/cart/add.js', { method:'POST', body: fd, headers: { Accept:'application/json' } })
        .then(r => r.json()).then(() => refresh().then(open))
        .catch(() => { form.submit(); });
    }
  });
})();
